export enum EventTypeModel {
    Post = "App\\Models\\FeedPost",
    Event = "App\\Models\\Event",
}